import { formatCurrency } from "@sa-nu/shared-utils/price";

import { ClassAdditionalFeeIntegrationNote } from "./class-additional-fee-integration-note";
import { DescriptionHeader } from "./description-header";

export type DescriptionForSelectionMessages = {
  headerLine1: string;
  headerLine2: string;
  withFee: (formattedFee: string) => string;
  noAdditionalFee: string;
  dynamicPricingNote: string;
};

const JA_MESSAGES: DescriptionForSelectionMessages = {
  headerLine1: "こちらのキャビンは、",
  headerLine2: "セレクションキャビンです",
  withFee: (formattedFee) =>
    `1泊あたり ${formattedFee}（税込）のセレクションキャビン利用料金がかかります。`,
  noAdditionalFee: "追加料金はかかりません。",
  dynamicPricingNote: "お部屋・日程により変動する追加料金がかかります",
};

/**
 * セレクションシリーズの説明
 *
 * @param additionalFee 追加料金
 * @param hasDynamicPricing 変動料金が適用されているかどうか
 * @param hideFixedFee 固定追加料金の表示を非表示にするか（Weekdayプラン向け）
 * @param ruleRevision2027AppliesFrom 2027年度改定のルールが適用される最初の宿泊日。指定するとクラス追加料金への統合の注記を出す
 */
export function DescriptionForSelection({
  additionalFee,
  hasDynamicPricing = false,
  hideFixedFee = false,
  ruleRevision2027AppliesFrom = null,
  messages = JA_MESSAGES,
}: {
  additionalFee: number;
  hasDynamicPricing?: boolean;
  hideFixedFee?: boolean;
  ruleRevision2027AppliesFrom?: string | null;
  messages?: DescriptionForSelectionMessages;
}) {
  return (
    <div className="mt-[20px] w-full space-y-[20px]">
      <DescriptionHeader
        iconSrc="/i/icon_selection.svg"
        iconAlt="Selection Series"
      >
        {messages.headerLine1}
        <br />
        {messages.headerLine2}
      </DescriptionHeader>
      <div className="text-xs md:text-sm">
        {!hideFixedFee &&
          (additionalFee > 0
            ? messages.withFee(
                formatCurrency(additionalFee, { unitCharacter: "円" }),
              )
            : messages.noAdditionalFee)}
        {hasDynamicPricing && (
          <>
            {!hideFixedFee && <br />}
            <span className="text-skogecha-60">
              {messages.dynamicPricingNote}
            </span>
          </>
        )}
        {ruleRevision2027AppliesFrom !== null && (
          <ClassAdditionalFeeIntegrationNote
            appliesFrom={ruleRevision2027AppliesFrom}
          />
        )}
      </div>
    </div>
  );
}
